<div class="dialog-container" [@openState]="state">
  <div class="dialog">
    <div class="heading">
      <h2>Filtrer la liste des entités</h2>
      <t-icon name="close" class="close" (click)="close()" title="Fermer"></t-icon>
    </div>
    <div class="content filter">

      <div class="search">
        <input
          #searchInput
          type="text"
          placeholder="Recherche..."
          [(ngModel)]="filter.search"
          (keyup)="searchKeyup($event)"
          autofocus />
        <button class="btn-search" (click)="apply()">
          <t-icon name="search"></t-icon>
        </button>
      </div>

      <div class="form-group" style="z-index: 20">
        <label for="has_movements">Registre des mouvements</label>
        <t-select
          id="has_movements"
          [items]="HAS_MOVEMENTS_OPTIONS"
          [(item)]="hasMovements"
          (updated)="apply()"
          ></t-select>
      </div>

      <div class="form-group" style="z-index: 10">
        <label for="order_by">Trier par</label>
        <t-select
          id="order_by"
          [items]="ORDER_BY_OPTIONS"
          [(item)]="orderBy"
          (updated)="apply()"
          ></t-select>
      </div>

      <!-- <div class="form-group">
        <label for="update_date">Date de modification</label>
        <t-select
          id="update_date"
          [items]="UPDATE_DATE_OPTIONS"
          [(item)]="updateDate"
          (updated)="apply()"
          ></t-select>
      </div> -->
    </div>
  </div>
</div>